import { css } from '@emotion/react'
import styles from '@mathflat/common/style'

const {
  colors: { primary, borderColor, gray },
} = styles

const S = {
  basic: css`
    position: relative;
    border: 1px solid ${borderColor};
    border-radius: var(--Radius-300);
    background-color: ${gray.$100};

    &::after {
      position: absolute;
      left: -1px;
      top: -1px;
      content: '';
      border-radius: var(--Radius-Circle);
    }
  `,

  default: css`
    width: 40px;
    height: 20px;

    &::after {
      width: 20px;
      height: 20px;
    }
  `,

  small: css`
    width: 30px;
    height: 15px;

    &::after {
      width: 15px;
      height: 15px;
    }
  `,

  on: css`
    &::after {
      background-color: ${primary};
      transform: translateX(100%);
      transition: all 0.12s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    }
    &.disabled::after {
      background-color: var(--Colors-Sky-200);
    }
  `,
  off: css`
    &::after {
      background-color: ${gray.$500};
      transform: translateX(0);
      transition: all 0.12s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    }
    &.disabled::after {
      background-color: var(--Colors-Gray-300);
    }
  `,
}

export default S
